<template>
  <section id="mainBanner" class="main-banner">
    <video-background
      :src="videoSrc"
      class="video-bg"
      overlay="radial-gradient(66.25% 121.93% at 70.64% -15.07%, rgb(129 132 249 / 44%) 12.26%, rgb(92 94 232 / 88%) 91.15%)"
    >
      <b-container class="h-100">
        <b-row class="h-100 align-content-md-center">
          <b-col sm="12" md="4" lg="4">
            <div class="banner-img-container">
              <img src="../assets/img/Logo-Grexy-banner.svg" alt="Logo Grexy">
            </div>
          </b-col>
          <b-col sm="12" md="8" lg="8">
            <div class="banner-container-content">
              <h1 class="banner-title" v-html="$t('banner_title')"></h1>
              <p class="banner-subtitle" v-html="$t('banner_subtitle')"></p>
              <div class="btn-shop-action">
                <a class="btn-shop" href="https://apps.apple.com/ua/app/grexy/id6470862283?l=uk" target="_blank"><img class="subscribe-icon" src="../assets/img/long-btn-appstore.png" alt="Registration image"></a>
                <a class="btn-shop" href="https://play.google.com/store/apps/details?id=com.grexy" target="_blank"><img class="subscribe-icon" src="../assets/img/long-btn-googleplay.png" alt="Registration image"></a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </video-background>
  </section>

</template>

<script>
import VideoBackground from 'vue-responsive-video-background-player'

export default {
  components: {
    VideoBackground
  },
  data () {
    return {
      videoSrc: require('../assets/video/bg-video.mp4')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.main-banner{
  min-height: 650px;
  position: relative;
  gap: 24px;
  .video-bg{
    height: 100vh;
    @media screen and (min-width: 320px) {
      max-height: calc(100vh - 80px);
    }
    @media screen and (min-width: 768px) {
      max-height: 500px;
    }
  }
  .btn-shop-action {
    display: flex;
    gap: 16px;
    img{
      width: 100%;
    }
  }
  @media screen and (min-width: 320px) {
    height: 100%;
    max-height: none;
    padding-top: 80px;
    video{
      display: none;
    }
  }
  @media screen and (min-width: 768px) {

  }
  @media screen and (min-width: 992px) {
    min-height: 560px;
    //height: 100vh;
    //max-height: 930px;
  }
  @media screen and (min-width: 1440px) {
    padding-top: 80px;
    min-height: 500px;
  }
  @media screen and (min-width: 1920px) {
    min-height: 570px;
    padding-top: 80px;
  }
  .banner-img-container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (min-width: 320px) {
      margin-top: 40px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-top: unset;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    img{
      width: 100%;
      height: auto;
      @media screen and (min-width: 320px) {
        max-width: 160px;
      }
      @media screen and (min-width: 768px) {
        max-width: 280px;
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
        max-width: 320px;
      }
      @media screen and (min-width: 1920px) {
        max-width: 402px;
      }
    }
  }
  .banner-container-content{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    @media screen and (min-width: 320px){
      margin-left: 0;
      justify-content: flex-start;
      position: relative;
      top: -9px;
    }
    @media screen and (min-width: 992px) {
      justify-content: center;
      position: unset;
      top: unset;
    }
    @media screen and (min-width: 1440px){
      margin-left: 66px;
    }
    .banner-title{
      color: #ffffff;
      font-family: $main-font;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      @media screen and (min-width: 320px) {
        font-size: 40px;
        line-height: 48px;
        margin: 0 0 16px 0;
      }
      @media screen and (min-width: 768px) {
        font-size: 32px;
      }
      @media screen and (min-width: 992px) {
        line-height: 120%;
      }
      @media screen and (min-width: 1440px) {
        font-size: 48px;
        margin-top: 0;
        margin-bottom: 24px;
      }
    }
    .banner-subtitle{
      color: #ffffff;
      font-family: $main-font;
      font-size: 24px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
      @media screen and (min-width: 320px) {
        font-size: 20px;
        margin: 0 0 40px 0;
      }
      @media screen and (min-width: 768px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1440px) {
        font-size: 24px;
        margin: 0 0 32px 0;
      }
    }
    .banner-btn-container{
      display: inline-flex;
      flex-direction: column;
      @media screen and (min-width: 320px){
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      @media screen and (min-width: 768px){
        width: auto;
      }
      .info-text{
        text-transform: capitalize;
        color: #FFDC5D;
        text-align: center;
        font-family: $main-font;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 0 0 4px 0;
      }
    }
  }
}
</style>
